/**
 * フロントのエンドポイント一覧管理
 */

export class EndpointPathNames {
  /**ホーム画面 */
  public static readonly HOME = "/home";

  /**Myデータ画面 */
  public static readonly MYDATA = "/mydata";

  /**ログイン画面 */
  public static readonly LOGIN = "/login";

  /**新規利用者登録画面 */
  public static readonly SIGN_UP = "/sign_up";

  /**利用者仮登録完了画面 */
  public static readonly SIGN_UP_DONE = "/sign_up_done";

  /**利用者パスワード登録画面 */
  public static readonly SIGN_UP_PASS = "/sign_up_pass";

  /**利用者名登録画面 */
  public static readonly SIGN_UP_USER = "/sign_up_user";

  /**利用者本登録完了画面 */
  public static readonly SIGN_UP_COMPLETED = "/sign_up_completed";

  /**利用者パスワードリセット開始画面 */
  public static readonly RESET_PASS = "/reset_pass";

  /**利用者パスワードリセットメール送信完了画面 */
  public static readonly RESET_PASS_DONE = "/reset_pass_done";

  /**利用者パスワードリセット新規パスワード設定画面 */
  public static readonly RESET_PASS_SET = "/reset_pass_set";

  /**利用者パスワードリセット完了画面 */
  public static readonly RESET_PASS_COMPLETED = "/reset_pass_completed";

  /**お知らせ */
  public static readonly NEWS = "/news";

  /**エラーページ */
  public static readonly ERROR = "/error";

  /**初回認証画面 */
  public static readonly FIRST_AUTH = "/first_auth";
}